import { useEffect, useRef, useState } from "react";
import { ShieldAlert } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PinInput } from "@/components/PinInput";
import { registerSuperPinPrompt } from "@/lib/api";

export const SuperPinPrompt = () => {
  const [req, setReq] = useState(null);
  const [pin, setPin] = useState("");
  const resolver = useRef(null);

  useEffect(() => {
    registerSuperPinPrompt((r) => new Promise((resolve) => {
      resolver.current = resolve;
      setPin("");
      setReq(r);
    }));
    return () => registerSuperPinPrompt(null);
  }, []);

  const finish = (value) => {
    resolver.current?.(value);
    resolver.current = null;
    setReq(null);
    setPin("");
  };

  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && finish(null)}>
      <DialogContent className="max-w-sm z-[100]" data-testid="super-pin-dialog">
        <DialogHeader>
          <div className="mx-auto h-12 w-12 rounded-full bg-gradient-to-br from-rose-600 to-orange-500 text-white flex items-center justify-center"><ShieldAlert className="h-6 w-6" /></div>
          <DialogTitle className="text-center">PIN Super Admin Diperlukan</DialogTitle>
          <DialogDescription className="text-center">
            Masukkan PIN Super Admin untuk menyetujui: <b className="text-slate-900" data-testid="super-pin-action">{req?.action}</b>
          </DialogDescription>
        </DialogHeader>
        <PinInput value={pin} onChange={setPin} onComplete={finish} testid="super-pin-input" />
        {req?.error && <p className="text-sm text-center text-red-600 font-medium" data-testid="super-pin-error">{req.error}</p>}
        <div className="flex gap-2">
          <button onClick={() => finish(null)} data-testid="super-pin-cancel" className="flex-1 border border-slate-200 hover:bg-slate-100 py-2.5 rounded-xl text-sm font-semibold">Batal</button>
          <button onClick={() => finish(pin)} disabled={pin.length !== 6} data-testid="super-pin-submit" className="flex-1 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white py-2.5 rounded-xl text-sm font-semibold">Setujui</button>
        </div>
        <p className="text-[11px] text-center text-slate-500">Setiap perubahan dicatat di Log Perubahan.</p>
      </DialogContent>
    </Dialog>
  );
};
